import CMSPage from "@/components/CMSPage";
import { Phone } from "lucide-react";

export default function RequestCallbackPage() {
  return (
    <CMSPage
      pageId="request-callback"
      defaultTitle="Request a Callback"
      defaultDescription="Speak to one of our property experts at a time that suits you. Request a callback and we'll get in touch to discuss your property needs."
      icon={Phone}
    />
  );
}
